module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/quote_img-52102fa4922faa304b27e9df03e7f153.png";